/**
 * src/web/components/chat-room-form-panel.jsx
 * 基本設定
 */

import React from 'react'
import connect from '../../connects/chat-room-form-panel'
import {
  Card,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button
} from 'react-toolbox/lib/button'
import theme from './themes/flat-card.css'
import {
  Input,
} from 'react-toolbox/lib/input'
// import Slider from 'react-toolbox/lib/slider' Slide in React Toolbx is buggy...
import 'react-rangeslider/lib/index.css'
import {
   linkUI 
} from '../../helpers/form-validator'
import { valid } from 'glamor';
import FileUploadButton from './file-upload-button.jsx'
import ProgressBar from 'react-toolbox/lib/progress_bar'
import Slider from 'react-rangeslider'
import AvatarEditor from 'react-avatar-editor'

function calcCrop(avatar) {
  if (!avatar)
    return undefined

  const rect = avatar.getCroppingRect()
  const width = avatar.state.image.resource.width
  const height = avatar.state.image.resource.height

  return {
    x: width * rect.x,
    y: height * rect.y,
    width: width * rect.width,
    height: height * rect.height,
  }
}

class ChatRoomFormPanel extends React.Component {
  state = { scale: 1.5 }
  render() {
    const {
      t,
      ui,
      user,
      isUpdating,
      validateAndSubmit,
      chatRoom,
      uploadFile,
      uploadedFile,
      isUploading,
    } = this.props

    return (
      <form onSubmit={(event)=> {validateAndSubmit(this.props, isUpdating, event, calcCrop(this.refs.avatar))}}>
        <Card theme={theme}>
          <CardText>
            <normal><strong>{t('label:チャットルーム名')}</strong></normal>
            <Input name="chatRoomName" required autoFocus
              label={t('label:チャットルーム名')}
              value={ui.name}
              icon='person'
              error={ui.nameError && t('error:チャットルーム名を入力してください')}
              onChange={linkUI(this, 'name')}
            />
          </CardText>

          <CardText>
            <normal><strong>{t('label:アイコン画像')}</strong></normal><br />
            {!uploadedFile && !isUploading &&
              <div>
                <img style={{ width: 100, height: 100, borderRadius: '50%' }} src={chatRoom.icon_image ? chatRoom.icon_image.thumb_url : chatRoom.members[0].icon_image.thumb_url} />
              </div>
            }
            {uploadedFile && !isUploading && uploadedFile.file &&
              <div style={{ display: 'flex', flexDirection: 'column', width: 210 }}>
                <AvatarEditor ref="avatar"
                    image={uploadedFile.file.thumb_url}
                    width={200}
                    height={200}
                    border={5}
                    scale={this.state.scale}
                    style={{ cursor: 'move' }} />
                <Slider
                    min={1}
                    max={5}
                    step={0.05}
                    tooltip={false}
                    value={this.state.scale}
                    onChange={(value)=> this.setState({ scale: value })} />
              </div>
            }
            {isUploading &&
              <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'flex-start', marginLeft: '10px' }}>
                <ProgressBar type='circular' multicolor mode='indeterminate' />
              </div>
            }
            <FileUploadButton raised
              icon='add_a_photo'
              label='ファイルを選択'
              single
              onChange={(file)=> uploadFile(this.props, file)} />
          </CardText>

          <CardActions>
            <Button raised primary
              type="submit"
              disabled={isUpdating}
              style={{ width: '100%' }}
              label={t('label:更新')}
              onClick={ (event)=> {validateAndSubmit(this.props, isUpdating, event, calcCrop(this.refs.avatar)) }} />
          </CardActions>
        </Card>
      </form>
    )
  }
}

export default connect(ChatRoomFormPanel)



// WEBPACK FOOTER //
// ./src/web/components/chat-room-form-panel.jsx